/* eslint-disable react-hooks/exhaustive-deps */
// Dashboard.tsx

import "./AdminDashboard.scss";

import {
  Box,
  Button,
  Card,
  InputAdornment,
  OutlinedInput,
  Typography,
} from "@mui/material";
import { IAPIConfig, useApi } from "../../custom_hooks/useApi";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Add } from "@mui/icons-material";
import AdjustIcon from "@mui/icons-material/Adjust";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import BOModal from "../../templates/Login/BOModal";
import ConnectToGoogleModal from "../../templates/Login/ConnectToGoogleModal";
import CustomDashboardAreaCharts from "./DashboardAreaCharts/CustomDashboardAreaCharts";
import CustomToast from "../../utils/cutomToast/CustomToast";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import FormControl from "@mui/material/FormControl";
import { GoogleLogin } from "@react-oauth/google";
import Grid from "@mui/material/Grid2";
import Label from "../../components/Label";
import LazyLoad from "react-lazyload";
import Loader from "../../utils/loader/Loader";
import MenuItem from "@mui/material/MenuItem";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import SearchIcon from "@mui/icons-material/Search";
import Select from "@mui/material/Select";
import dayjs from "dayjs";
import { setExpandedBusiness } from "../../store/businessSlice";
import { urlConstants } from "../../components/constants/globalConstants";
import { useBusinessProfileApis } from "../../custom_hooks/useBusinessProfileApis";
import { useConfirmDialog } from "../../components/Dialog/ConfirmDialogContext";
import { useNavigate } from "react-router-dom";

//import StarIcon from "@mui/icons-material/Star";

type TransformedObject = {
  Name: string;
  Description: string;
  Website: string;
  ProductsServices: string[];
  LocationType: string;
  Locations: string[];
  CustomerPersonas: { personName: string; personDescription: string }[] | null;
  SellingPoints: string[] | null;
  BusinessObjective: string | null;
  Competitors: { name: string; website: string }[] | null;
  UniqueId: string;
};

const AdminDashboard: React.FC = () => {
  //const [selectedTab, setSelectedTab] = useState(0);
  const [month, setMonth] = useState<string>("3 months");
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState<string>("");
  //const [ga4BusinessPreviews, setGa4BusinessPreviews] = useState<any>([]);
  const [gscBusinessPreviews, setGscBusinessPreviews] = useState<any>([]);
  // const [gbpBusinessPreviews, setGbpBusinessPreviews] = useState<any>([]);
  // const [filteredGa4, setFilteredGa4] = useState<any[]>([]);
  const [filteredGsc, setFilteredGsc] = useState<any[]>([]);
  //const [filteredGbp, setFilteredGbp] = useState<any[]>([]);
  const { doApi } = useApi();
  const { userDetails } = useSelector((state: any) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [screenHeight, setScreenHeight] = useState(window.innerHeight);
  const [addBusinessProfileModalOpen, setAddBusinessProfileModalOpen] =
    useState(false);
  const { showConfirmDialog } = useConfirmDialog();
  const [businessDataDetails, setBusinessDataDetails] = useState({
    Website: "",
    Name: "",
    PrimaryLocation: {
      Location: "",
      Country: "",
    },
    Category: "",
    Description: "",
    LocationType: "",
    BusinessObjective: "",
    BusinessModel: "",
    CustomerPersonas: [],
    Competitors: [],
    Locations: [],
    ProductsServices: [],
  });
  const [step, setStep] = useState<
    "businessDetails" | "offerings" | "connectGoogle"
  >("businessDetails");
  const [currentBusinessProfile, setCurrentBusinessProfile] =
    useState<any>(null);
  const [connectToGoogle, setConnectToGoogle] = useState(false);
  const { GetBusinessProfilesData } = useBusinessProfileApis();

  useEffect(() => {
    const updateScreenHeight = () => {
      setScreenHeight(window.innerHeight);
    };

    // Add event listener to update screen height on resize
    window.addEventListener("resize", updateScreenHeight);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", updateScreenHeight);
    };
  }, []);

  const businessProfiles = useSelector(
    (state: any) => state.businessDetails.profiles
  );

  useEffect(() => {
    const filterData = (data: any[]) =>
      data.filter((item) =>
        item.url.toLowerCase().includes(searchQuery.toLowerCase())
      );

    //setFilteredGa4(filterData(ga4BusinessPreviews));
    setFilteredGsc(filterData(gscBusinessPreviews));
    //setFilteredGbp(filterData(gbpBusinessPreviews));
  }, [
    searchQuery,
    //ga4BusinessPreviews,
    gscBusinessPreviews,
    //gbpBusinessPreviews,
  ]);

  // const fetchGa4AllBusinessPreviews = useCallback(async () => {
  //   try {
  //     const payload = {
  //       origin: "ui",
  //       useruniqueId: userDetails.uniqueId,
  //       mode: "web",
  //       period: month,
  //       dimensions: [{ name: "date" }],
  //       metrics: [{ name: "Key events" }, { name: "Sessions" }],
  //     };
  //     const fetchGa4AllBusinessPreviewsConfig: IAPIConfig = {
  //       URL: "GA4/FetchAllBusinessPreviews",
  //       method: "POST",
  //       payLoad: payload,
  //     };
  //     const res: any = await doApi(
  //       fetchGa4AllBusinessPreviewsConfig,
  //       "seedcore"
  //     );

  //     if (res.status === 200 && !res.data.err) {
  //       setGa4BusinessPreviews(res.data.data);
  //     } else {
  //       setGa4BusinessPreviews([]);
  //       CustomToast(res.data.message, "error");
  //     }
  //   } catch (err: any) {
  //     CustomToast(err.message, "error");
  //     setGa4BusinessPreviews([]);
  //   }
  // }, [userDetails.uniqueId, month]);

  const fetchGscAllBusinessPreviews = useCallback(async () => {
    try {
      const payload = {
        origin: "ui",
        useruniqueId: userDetails.uniqueId,
        mode: "organic",
        period: month,
        dimensions: [{ name: "date" }],
      };
      const fetchGscAllBusinessPreviewsConfig: IAPIConfig = {
        URL: "GSC/FetchAllBusinessPreviews",
        method: "POST",
        payLoad: payload,
      };
      const res: any = await doApi(
        fetchGscAllBusinessPreviewsConfig,
        "seedcore"
      );

      if (res.status === 200 && !res.data.err) {
        setGscBusinessPreviews(res.data.data);
      } else {
        setGscBusinessPreviews([]);
        CustomToast(res.data.message, "error");
      }
    } catch (err: any) {
      CustomToast(err.message, "error");
      setGscBusinessPreviews([]);
    }
  }, [userDetails.uniqueId, month]);

  // const fetchGbpAllBusinessPreviews = useCallback(async () => {
  //   try {
  //     const payload = {
  //       origin: "ui",
  //       useruniqueId: userDetails.uniqueId,
  //       mode: "web",
  //       period: month,
  //       dimensions: [{ name: "date" }],
  //       metrics: [
  //         {
  //           name: "Sessions",
  //         },
  //         {
  //           name: "Key events",
  //         },
  //       ],
  //     };
  //     const fetchGbpAllBusinessPreviewsConfig: IAPIConfig = {
  //       URL: "Review/FetchAllBusinessPreviews",
  //       method: "POST",
  //       payLoad: payload,
  //     };
  //     const res: any = await doApi(
  //       fetchGbpAllBusinessPreviewsConfig,
  //       "seedcore"
  //     );

  //     if (res.status === 200 && !res.data.err) {
  //       setGbpBusinessPreviews(res.data.data);
  //     } else {
  //       setGbpBusinessPreviews([]);
  //       CustomToast(res.data.message, "error");
  //     }
  //   } catch (err: any) {
  //     CustomToast(err.message, "error");
  //     setGbpBusinessPreviews([]);
  //   }
  // }, [userDetails.uniqueId, month]);

  // const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
  //   setSelectedTab(newValue);
  // };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        await fetchGscAllBusinessPreviews();
        //await fetchGa4AllBusinessPreviews();
        // switch (selectedTab) {
        //   case 0:
        //     await fetchGscAllBusinessPreviews();
        //     break;
        //   case 1:
        //     await fetchGa4AllBusinessPreviews();
        //     break;
        //   case 2:
        //     await fetchGbpAllBusinessPreviews();
        //     break;
        //   default:
        //     break;
        // }
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [month, fetchGscAllBusinessPreviews]);

  const timePerios = useMemo(
    () => [
      {
        id: 1,
        label: "7 days",
        value: "7 days",
      },
      {
        id: 2,
        label: "14 days",
        value: "14 days",
      },
      {
        id: 3,
        label: "28 days",
        value: "28 days",
      },
      {
        id: 4,
        label: "3 months",
        value: "3 months",
      },
      {
        id: 5,
        label: "6 months",
        value: "6 months",
      },
      {
        id: 6,
        label: "12 months",
        value: "12 months",
      },
    ],
    []
  );

  const extractDomainName = (input: string): string => {
    try {
      // Check if input starts with a protocol (e.g., http, https)
      const hasProtocol = /^https?:\/\//i.test(input);
      const hostname = hasProtocol ? new URL(input).hostname : input;

      // Remove leading "www."
      const cleanHost = hostname.replace(/^www\./, "");

      const parts = cleanHost.split(".");
      const len = parts.length;

      // Return second-level domain (e.g., vertaccount from test.vertaccount.com)
      return len >= 2 ? parts[len - 2] : cleanHost;
    } catch (error) {
      console.error("Invalid input:", input);
      return input;
    }
  };

  const handleExpandBusiness = (businessData: TransformedObject) => {
    setTimeout(() => {
      dispatch(setExpandedBusiness(businessData.Name));
      navigate(`/analytics?uuid=${businessData.UniqueId}`, {
        state: { businessData },
      });
    }, 1000);
  };

  const handleCardClick = async (e: any, url: string) => {
    e.preventDefault();
    const filterBusiness: TransformedObject[] = businessProfiles.filter(
      (business: TransformedObject) => {
        return business.Website.toLowerCase() === url.toLowerCase();
      }
    );
    handleExpandBusiness(filterBusiness[0]);
  };

  const handleAddBusinessProfile = () => {
    setAddBusinessProfileModalOpen(true);
  };

  const handleGoBack = () => {
    if (step === "businessDetails") {
      setAddBusinessProfileModalOpen(false);
      setStep("businessDetails");
    }
    if (step === "offerings") return;
  };

  const createAgencyBusiness = async () => {
    try {
      setLoading(true);

      const payload = {
        userUniqueId: userDetails.uniqueId || "",
        accountUniqueId: "",
        businesses: [
          {
            name: businessDataDetails?.Name,
            description: "",
            website: businessDataDetails?.Website,
            displayName: businessDataDetails?.Name,
            locationType: businessDataDetails?.LocationType,
            propertyId: "",
            category: "",
            brandVoice: "",
            businessModel: "",
            productsServices: [],
            locations: null,
            customerPersonas: null,
            sellingPoints: null,
            businessObjective: businessDataDetails?.BusinessObjective,
            competitors: null,
            uniqueId: "",
            primaryLocation: businessDataDetails?.PrimaryLocation,
            userUniqueId: userDetails.uniqueId || "",
          },
        ],
      };

      const config: IAPIConfig = {
        URL: `/Profile/CreateAgencyBusinesses`,
        method: "POST",
        payLoad: payload,
      };

      const res: any = await doApi(config, "seedcore");

      if (res.status === 200) {
        const updatedProfiles = await GetBusinessProfilesData();
        const finalUpdatedProfiles = JSON.parse(updatedProfiles.data);
        const websiteInput = businessDataDetails.Website.toLowerCase().trim();

        const matchedProfile = finalUpdatedProfiles.find((profile: any) => {
          const profileWebsite = profile.Website?.toLowerCase().trim() || "";
          return (
            profileWebsite.includes(websiteInput) ||
            websiteInput.includes(profileWebsite)
          );
        });
        setCurrentBusinessProfile(matchedProfile || null);

        CustomToast("Businesses connected successfully", "success");
        return true;
      } else {
        CustomToast("Failed to connect businesses", "error");
        return false;
      }
    } catch (error) {
      CustomToast("An error occurred. Please try again.", "error");
      return false;
    } finally {
      setLoading(false);
    }
  };

  const handleContinue = async () => {
    if (step === "businessDetails") {
      if (
        businessDataDetails.Website.trim() === "" ||
        businessDataDetails.Name.trim() === "" ||
        businessDataDetails.PrimaryLocation.Location.trim() === "" ||
        businessDataDetails.PrimaryLocation.Country.trim() === "" ||
        businessDataDetails.BusinessObjective.trim() === "" ||
        businessDataDetails.LocationType.trim() === ""
      ) {
        CustomToast("Please enter all fields", "error");
        return;
      }

      if (await createAgencyBusiness()) {
        setStep("offerings");
      }
    }
    if (step === "offerings") {
      setStep("connectGoogle");
      setConnectToGoogle(true);
      setStep("connectGoogle");
    }
  };

  const handleConnectGoogle = () => {
    window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?scope=openid%20profile%20email https://www.googleapis.com/auth/business.manage https://www.googleapis.com/auth/webmasters.readonly https://www.googleapis.com/auth/webmasters https://www.googleapis.com/auth/analytics.readonly https://www.googleapis.com/auth/userinfo.email&prompt=consent&access_type=offline&include_granted_scopes=true&response_type=code&state=state_parameter_passthrough_value&redirect_uri=${urlConstants.ENV_URL}/signin-google&flowName=GeneralOAuthFlow&client_id=${urlConstants.CLIENT_ID}`;
  };

  const handleSkipForNow = () => {
    if (step === "connectGoogle") {
      setAddBusinessProfileModalOpen(false);
      setStep("businessDetails");
    }
    if (step === "offerings") {
      setStep("connectGoogle");
    }
    if (step === "connectGoogle") {
      setConnectToGoogle(false);
      setAddBusinessProfileModalOpen(false);
      setStep("businessDetails");
    }
  };

  console.log("step", step);

  const ConnectGoogleAccount = () => {
    window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?scope=openid%20profile%20email https://www.googleapis.com/auth/business.manage https://www.googleapis.com/auth/webmasters.readonly https://www.googleapis.com/auth/webmasters https://www.googleapis.com/auth/analytics.readonly https://www.googleapis.com/auth/userinfo.email&prompt=consent&access_type=offline&include_granted_scopes=true&response_type=code&state=state_parameter_passthrough_value&redirect_uri=${urlConstants.ENV_URL}/signin-google&flowName=GeneralOAuthFlow&client_id=${urlConstants.CLIENT_ID}`;
  };

  return (
    <Box className="dashboard" sx={{ minHeight: "100vh" }}>
      <Box sx={{ maxWidth: "1300px" }}>
        {step === "businessDetails" || step === "offerings" ? (
          <BOModal
            open={addBusinessProfileModalOpen}
            currentBusinessProfile={currentBusinessProfile}
            handleClose={() => setAddBusinessProfileModalOpen(false)}
            step={step}
            handleSkipForNow={handleSkipForNow}
            handleGoBack={handleGoBack}
            handleContinue={handleContinue}
            steps={["Business Details", "Offerings"]}
            businessDataDetails={businessDataDetails}
            setBusinessDataDetails={setBusinessDataDetails}
          />
        ) : (
          <ConnectToGoogleModal
            open={connectToGoogle}
            handleClose={() => {
              setConnectToGoogle(false);
              setAddBusinessProfileModalOpen(false);
              setStep("businessDetails");
            }}
            ConnectGoogle={handleConnectGoogle}
            handleSkipForNow={handleSkipForNow}
          />
        )}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          marginBottom={4}
        >
          <Box display="flex" alignItems="center" gap={2}>
            <FormControl sx={{ m: 1, width: "25ch" }} variant="outlined">
              <OutlinedInput
                id="outlined-adornment-weight"
                size="small"
                placeholder="Enter Business Name"
                sx={{
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#0000003B",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#0F4343",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#0F4343",
                    borderWidth: "1px",
                  },
                  "&.Mui-focused": {
                    boxShadow: "none !important",
                    outline: "none !important",
                  },
                }}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                endAdornment={
                  <InputAdornment position="end">
                    <SearchIcon sx={{ color: "#00000014" }} />
                  </InputAdornment>
                }
              />
            </FormControl>
            <Box sx={{ minWidth: 120 }}>
              <FormControl fullWidth>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={month}
                  onChange={(e) => {
                    setMonth(e.target.value);
                  }}
                  sx={{
                    color: "#6e6b6b",
                    height: "40px",
                    outline: "none",
                    background: "#fff",
                    border: "none",
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                  }}
                >
                  {timePerios.map((timePeriod) => (
                    <MenuItem key={timePeriod.id} value={timePeriod.value}>
                      {timePeriod.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Box>
          <Button
            variant="contained"
            color="primary"
            size="large"
            startIcon={<Add />}
            onClick={handleAddBusinessProfile}
          >
            Add Business Profile
          </Button>
        </Box>
        {filteredGsc.length > 0 && (
          <>
            {/* Calculate valid count */}
            {(() => {
              const validCount = filteredGsc.filter((item: any) => {
                const mainStats = JSON.parse(item.mainstats || "{}");
                return (
                  mainStats?.Clicks?.Total === undefined &&
                  mainStats?.Impressions?.Total === undefined
                );
              }).length;

              return validCount > 0 ? (
                <Box
                  bgcolor={"#FDEDED"}
                  paddingY={1}
                  borderRadius={1}
                  paddingX={2}
                  display={"flex"}
                  alignItems={"center"}
                  gap={1.5}
                >
                  <Box
                    width={"22px"}
                    height={"22px"}
                    color={"#CD3535"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                  >
                    <ErrorOutlineIcon />
                  </Box>
                  <Typography variant="body2" color="#5F2120" fontWeight={500}>
                    {filteredGsc.length - validCount} of {filteredGsc.length}{" "}
                    businesses need more info to generate a complete summary. It
                    just takes a few minutes!
                  </Typography>
                </Box>
              ) : null;
            })()}
          </>
        )}

        <Loader spinning={loading}>
          <Box className="tab-contents" marginTop={4}>
            <LazyLoad height={screenHeight / 2} offset={screenHeight / 4}>
              <Box className="cardContainer">
                <Grid
                  container
                  rowSpacing={2}
                  columnSpacing={{ xs: 2 }}
                  sx={{
                    display: "grid",
                    gridTemplateColumns: {
                      xs: "1fr",
                      sm: "repeat(2, 1fr)",
                      md: "repeat(2, 1fr)",
                      lg: "repeat(2, 1fr)",
                      xl: "repeat(3, 1fr)",
                    },
                  }}
                >
                  {filteredGsc.map((item: any, index: number) => {
                    const mainStats = JSON.parse(item.mainstats || "{}");
                    console.log("mainstats", mainStats);
                    const graphData = JSON.parse(item.graph || "{}");
                    console.log("graphData", graphData);
                    const hasGraphRows = graphData?.rows?.length > 0;
                    console.log("hasGraphRows", hasGraphRows);

                    const clicks = mainStats?.Clicks || {};
                    const impressions = mainStats?.Impressions || {};
                    const goals = mainStats?.goals || {};

                    const showConnectAnalytics =
                      Object.keys(goals).length === 0;
                    const showConnectGoogle =
                      Object.keys(clicks).length === 0 ||
                      Object.keys(impressions).length === 0;
                    return (
                      <Grid key={index}>
                        <Card
                          className="card"
                          style={{ cursor: "pointer" }}
                          elevation={0}
                        >
                          <Box
                            className="card-title"
                            borderBottom={"1px solid #0000000F"}
                            paddingY={1}
                            paddingX={1.5}
                          >
                            <Typography variant="h6">
                              {extractDomainName(item.url)}
                            </Typography>
                          </Box>

                          {/* Conditional Connection Prompts */}
                        
                            <Box
                              bgcolor={"#CD3535"}
                              paddingX={2}
                              paddingY={0.8}
                              color="#fff"
                              display={"flex"}
                              alignItems={"center"}
                              gap={1}
                              sx={{
                                opacity: `${showConnectAnalytics ? "1" : "0"}`,
                                pointerEvents: `${showConnectAnalytics ? "auto" : "none"}`,
                                cursor: `${showConnectAnalytics ? "pointer" : "not-allowed"}`,
                              }}
                            >
                              <Box
                                width={"18px"}
                                height={"18px"}
                                color={"#ffffff"}
                                display={"flex"}
                                alignItems={"center"}
                                justifyContent={"center"}
                              >
                                <ErrorOutlineIcon />
                              </Box>
                              <Typography
                                variant="caption"
                                sx={{
                                  textDecoration: "underline",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  showConfirmDialog({
                                    title: "Suggestion",
                                    message: `Connect Google Analytics for this business to the google account you use to integrate with Massic.`,
                                    confirmText: "Connect",
                                    cancelText: "Cancel",
                                    onConfirm: () => {
                                      setConnectToGoogle(true);
                                      setStep("connectGoogle");
                                    },
                                    onCancel: () => {
                                      console.log("Trigger action cancelled!");
                                    },
                                  });
                                }}
                              >
                                Connect Google Analytics
                              </Typography>
                            </Box>
                        

                          {/* Chart or GoogleLogin */}
                          <Box sx={{ marginTop: 1, marginBottom: 1 }}>
                            {hasGraphRows ? (
                              <Box
                                onClick={(e) => handleCardClick(e, item.url)}
                              >
                                <CustomDashboardAreaCharts
                                  key={JSON.stringify(graphData)}
                                  chartType="area"
                                  categories={graphData.rows.map((point: any) =>
                                    dayjs(point.keys[0]).format("YYYY-MM-DD")
                                  )}
                                  seriesData={[
                                    {
                                      name: "Clicks",
                                      data: graphData.rows.map((point: any) =>
                                        parseInt(point.clicks, 10)
                                      ),
                                    },
                                    {
                                      name: "Impressions",
                                      data: graphData.rows.map((point: any) =>
                                        parseInt(point.impressions, 10)
                                      ),
                                    },
                                    {
                                      name: "Goals",
                                      data: graphData.rows.map((point: any) =>
                                        parseInt(point.goal, 10)
                                      ),
                                    },
                                  ]}
                                  title="Custom Chart Title"
                                />
                              </Box>
                            ) : (
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  height: "200px",
                                }}
                              >
                                <GoogleLogin
                                  onSuccess={ConnectGoogleAccount}
                                  onError={() =>
                                    CustomToast("Failed to connect.", "error")
                                  }
                                />
                              </Box>
                            )}
                          </Box>

                          {/* Stats Summary */}
                          {!showConnectGoogle && (
                            <Box
                              paddingX={1}
                              paddingBottom={1}
                              display={"flex"}
                              gap={1}
                            >
                              {/* Clicks */}
                              <Box
                                bgcolor={"#F5F5F5"}
                                display={"flex"}
                                alignItems={"center"}
                                justifyContent={"center"}
                                gap={0.5}
                                flex={1}
                                padding={0.5}
                                borderRadius={1}
                              >
                                <Box
                                  width={"16px"}
                                  height={"16px"}
                                  color={"#5E35B180"}
                                  display={"flex"}
                                  justifyContent={"center"}
                                  alignItems={"center"}
                                >
                                  <RemoveRedEyeOutlinedIcon
                                    sx={{ width: "100%" }}
                                  />
                                </Box>
                                <Typography variant="caption" color="#5E35B1">
                                  {clicks.Total}
                                </Typography>
                                <Label
                                  increase={clicks.Trend === "up"}
                                  label={clicks.Diff}
                                  color={
                                    clicks.Trend === "up" ? "success" : "error"
                                  }
                                  size="10px"
                                />
                              </Box>

                              {/* Impressions */}
                              <Box
                                bgcolor={"#F5F5F5"}
                                display={"flex"}
                                alignItems={"center"}
                                gap={0.5}
                                flex={1}
                                justifyContent={"center"}
                                padding={0.5}
                                borderRadius={1}
                              >
                                <Box
                                  width={"16px"}
                                  height={"16px"}
                                  color={"#4285F480"}
                                  display={"flex"}
                                  justifyContent={"center"}
                                  alignItems={"center"}
                                >
                                  <ArrowOutwardIcon sx={{ width: "100%" }} />
                                </Box>
                                <Typography variant="caption" color="#4285F4">
                                  {impressions.Total}
                                </Typography>
                                <Label
                                  increase={impressions.Trend === "up"}
                                  label={impressions.Diff}
                                  color={
                                    impressions.Trend === "up"
                                      ? "success"
                                      : "error"
                                  }
                                  size="10px"
                                />
                              </Box>

                              {/* Goals */}
                              <Box
                                bgcolor={"#F5F5F5"}
                                display={"flex"}
                                alignItems={"center"}
                                gap={0.5}
                                justifyContent={"center"}
                                flex={1}
                                padding={0.5}
                                borderRadius={1}
                              >
                                <Box
                                  width={"16px"}
                                  height={"16px"}
                                  color={"#00897B80"}
                                  display={"flex"}
                                  justifyContent={"center"}
                                  alignItems={"center"}
                                >
                                  <AdjustIcon sx={{ width: "100%" }} />
                                </Box>
                                <Typography variant="caption" color="#00897B">
                                  {goals.Total}
                                </Typography>
                                <Label
                                  increase={goals.Trend === "up"}
                                  label={goals.Diff}
                                  color={
                                    goals.Trend === "up" ? "success" : "error"
                                  }
                                  size="10px"
                                />
                              </Box>
                            </Box>
                          )}
                        </Card>
                      </Grid>
                    );
                  })}
                </Grid>
              </Box>
            </LazyLoad>
          </Box>
        </Loader>
      </Box>
    </Box>
  );
};

export default AdminDashboard;

// {filteredGa4.length > 0 &&
//                     filteredGa4.map((item: any, index: number) => {
//                       // Parse the JSON strings from mainstats and graph
//                       const mainStats = JSON.parse(item.mainstats);
//                       const graphData = JSON.parse(item.graph);
//                       if (graphData?.rows?.length === 0) {
//                         setValid((val: number) => val + 1);
//                       }
//                       // Extract sessions and conversions info
//                       const sessions = mainStats.Sessions;
//                       const conversions = mainStats.Conversions;
//                       debugger;
//                       return (
//                         <Grid key={index}>
//                           {/* New Card */}
//                           <Card
//                             className="card"
//                             onClick={(e) => handleCardClick(e, item.url)}
//                             style={{ cursor: "pointer" }}
//                             elevation={0}
//                           >
//                             <Box
//                               className="card-title"
//                               borderBottom={"1px solid #0000000F"}
//                               paddingY={1}
//                               paddingX={1.5}
//                             >
//                               <Typography variant="h6">
//                                 {extractDomainName(item.url)}
//                               </Typography>
//                             </Box>
//                             {filteredGa4.length === 0 && (
//                               <Box
//                                 bgcolor={"#CD3535"}
//                                 paddingX={2}
//                                 paddingY={0.8}
//                                 color="#fff"
//                                 display={"flex"}
//                                 alignItems={"center"}
//                                 gap={1}
//                               >
//                                 <Box
//                                   width={"18px"}
//                                   height={"18px"}
//                                   color={"#ffffff"}
//                                   display={"flex"}
//                                   alignItems={"center"}
//                                   justifyContent={"center"}
//                                 >
//                                   <ErrorOutlineIcon />
//                                 </Box>
//                                 <Typography
//                                   variant="caption"
//                                   sx={{
//                                     textDecoration: "underline",
//                                     cursor: "pointer",
//                                   }}
//                                 >
//                                   Connect Google Analytics
//                                 </Typography>
//                               </Box>
//                             )}
//                             <Box sx={{ marginTop: 1, marginBottom: 1 }}>
//                               <CustomDashboardAreaCharts
//                                 key={JSON.stringify(graphData)}
//                                 chartType="area"
//                                 categories={graphData.map((point: any) =>
//                                   dayjs(point.curDate).format("YYYY-MM-DD")
//                                 )}
//                                 seriesData={[
//                                   {
//                                     name: "Sessions",
//                                     data: graphData.map((point: any) =>
//                                       parseInt(point?.curData["Sessions"], 10)
//                                     ),
//                                   },
//                                   {
//                                     name: "Conversions",
//                                     data: graphData.map((point: any) =>
//                                       parseInt(point?.curData.Conversions, 10)
//                                     ),
//                                   },
//                                 ]}
//                                 title="Custom Chart Title"
//                               />
//                             </Box>
//                             <Box
//                               paddingX={1}
//                               paddingBottom={1}
//                               display={"flex"}
//                               gap={1}
//                             >
//                               {/* Impressions */}
//                               <Box
//                                 bgcolor={"#F5F5F5"}
//                                 display={"flex"}
//                                 alignItems={"center"}
//                                 justifyContent={"center"}
//                                 gap={0.5}
//                                 flex={1}
//                                 padding={0.5}
//                                 borderRadius={1}
//                               >
//                                 <Box
//                                   width={"16px"}
//                                   height={"16px"}
//                                   color={"#5E35B180"}
//                                   display={"flex"}
//                                   justifyContent={"center"}
//                                   alignItems={"center"}
//                                 >
//                                   <RemoveRedEyeOutlinedIcon
//                                     sx={{ width: "100%" }}
//                                   />
//                                 </Box>
//                                 <Typography variant="caption" color="#5E35B1">
//                                   {sessions.Total}
//                                 </Typography>
//                                 <Label
//                                   increase={sessions.Trend === "up"}
//                                   label={sessions.Diff}
//                                   color={
//                                     sessions.Trend === "up"
//                                       ? "success"
//                                       : "error"
//                                   }
//                                   size="10px"
//                                 />
//                               </Box>

//                               <Box
//                                 bgcolor={"#F5F5F5"}
//                                 display={"flex"}
//                                 alignItems={"center"}
//                                 gap={0.5}
//                                 flex={1}
//                                 justifyContent={"center"}
//                                 padding={0.5}
//                                 borderRadius={1}
//                               >
//                                 <Box
//                                   width={"16px"}
//                                   height={"16px"}
//                                   color={"#4285F480"}
//                                   display={"flex"}
//                                   justifyContent={"center"}
//                                   alignItems={"center"}
//                                 >
//                                   <ArrowOutwardIcon sx={{ width: "100%" }} />
//                                 </Box>
//                                 <Typography variant="caption" color="#4285F4">
//                                   {conversions.Total}
//                                 </Typography>
//                                 <Label
//                                   increase={conversions.Trend === "up"}
//                                   label={conversions.Diff}
//                                   color={
//                                     conversions.Trend === "up"
//                                       ? "success"
//                                       : "error"
//                                   }
//                                   size="10px"
//                                 />
//                               </Box>
//                             </Box>
//                           </Card>
//                         </Grid>
//                       );
//                     })}
